import { ca } from '@cian/analytics';
import { TShowPhoneAction } from '../../types/analytics/call';

export function trackShowPhone(customPageURL: string, action: TShowPhoneAction = 'Open_jk_card_blockJK') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action,
    label: customPageURL,
    useLastProducts: true,
  });
}

export function trackOpenContacts(customPageURL: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardJK',
    action: 'open_contacts',
    label: customPageURL,
    useLastProducts: true,
  });
}
